import { createAction } from 'typesafe-actions';

export const setPage = createAction('ORGANIZATION_PAGE_SET', action => (pageIndex: number) => action(pageIndex));

export const setPageSize = createAction('ORGANIZATION_PAGE_SIZE_SET', action => (pageSize: number) => action(pageSize));
